import {
  TableHead,
  TableRow,
  Checkbox,
  Button,
  styled,
} from '@mui/material'
import TableCell, { tableCellClasses } from '@mui/material/TableCell'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp'
import RemoveIcon from '@mui/icons-material/Remove'

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    padding: '4px 16px',
    backgroundColor: '#eee',
    color: '#000',
    fontSize: 12,
    '& button': {
      fontSize: 12,
      color: '#000',
    }
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}))

const DynamicHead = ({
  list, 
  sortDirection, 
  changeDirection, 
  onSelectAllClick, 
  isAllChecked,
  height,
}) => {
  return (
    <TableHead sx={{height}}>
      <TableRow align="center">
        {list.map((data, index) => {
          const {name, key, sort, checkbox, width} = data
          return (
            <StyledTableCell align="center" key={index} sx={{width}}>
              {checkbox && <Checkbox
                sx={{ml: .2}}
                color="primary"
                onChange={onSelectAllClick}
                checked={isAllChecked}
              />}
              {sort ? (
                <SortTableCell
                  title={name}
                  itemKey={key}
                  direction={sortDirection && sortDirection[key]}
                  changeDirection={changeDirection}
                />
              ) : (
                name
              )}
            </StyledTableCell>
          )
        })}
      </TableRow>
    </TableHead>
  )
}

const SortTableCell = ({title, itemKey, direction, changeDirection}) => {
  const handleChangeDirection = () => {
    let nextDirection = '';
    if (direction === 'ASC') {
      nextDirection = 'DESC';
    } else if (direction === 'DESC') {
      nextDirection = '';
    } else {
      nextDirection = 'ASC';
    }
    changeDirection(itemKey, nextDirection);
  };

  const renderArrowIcon = () => {
    if (direction === 'ASC') {
      return <ArrowDropUpIcon />;
    } else if (direction === 'DESC') {
      return <ArrowDropDownIcon />;
    }
    return <RemoveIcon sx={{fontSize: 11, ml: 0.5}} />;
  };

  return (
    <Button onClick={handleChangeDirection}>
      {title} {renderArrowIcon()}
    </Button>
  );
};

export default DynamicHead;